
import { useState } from 'react';

export default function Curriculum() {
  const [selectedPeriod, setSelectedPeriod] = useState(0);

  const periods = [
    {
      season: '春',
      title: '基礎固め期',
      description: '中1・中2の総復習を徹底。苦手単元を洗い出し、基礎学力を確実に定着させます。',
      image: 'https://public.readdy.ai/ai/img_res/ef40a3d9443a046200f185afce1717a4.jpg'
    },
    {
      season: '夏',
      title: '総復習期',
      description: '夏期講習で全範囲を総復習。弱点を徹底的に克服し、実力を大幅にアップさせます。',
      image: 'https://readdy.ai/api/search-image?query=summer%20intensive%20study%20session%20with%20student%20focused%20on%20practice%20problems%2C%20bright%20sunlight%20through%20window%2C%20determination%20and%20concentration%2C%20educational%20materials%20spread%20on%20desk%2C%20motivational%20atmosphere&width=600&height=400&seq=summer-study-001&orientation=landscape'
    },
    {
      season: '秋',
      title: '実戦演習期',
      description: '過去問演習を開始。時間配分や解答テクニックを習得し、実戦力を養います。',
      image: 'https://readdy.ai/api/search-image?query=autumn%20study%20with%20practice%20exam%20papers%20and%20timer%20on%20desk%2C%20focused%20learning%20environment%2C%20warm%20orange%20lighting%2C%20serious%20exam%20preparation%20atmosphere%2C%20organized%20study%20materials&width=600&height=400&seq=autumn-study-001&orientation=landscape'
    },
    {
      season: '冬',
      title: '過去問・直前対策期',
      description: '志望校の過去問を徹底分析。出題傾向を把握し、合格点を確実に取る力を養います。',
      image: 'https://readdy.ai/api/search-image?query=winter%20exam%20preparation%20with%20past%20exam%20papers%20stacked%20on%20desk%2C%20cozy%20study%20lamp%20lighting%2C%20determined%20student%20atmosphere%2C%20final%20preparation%20mood%2C%20educational%20focus&width=600&height=400&seq=winter-study-001&orientation=landscape'
    },
    {
      season: '入試直前',
      title: '最終仕上げ期',
      description: '最後の総仕上げ。弱点の最終確認と、本番で実力を発揮するためのメンタルケアも実施。',
      image: 'https://readdy.ai/api/search-image?query=final%20exam%20preparation%20with%20motivational%20notes%20and%20study%20materials%2C%20confident%20atmosphere%2C%20bright%20encouraging%20lighting%2C%20success%20mindset%2C%20organized%20desk%20with%20exam%20schedule&width=600&height=400&seq=final-study-001&orientation=landscape'
    }
  ];

  return (
    <section className="py-16 md:py-24 px-6 md:px-12 bg-white">
      <div className="max-w-lg md:max-w-4xl lg:max-w-6xl mx-auto">
        {/* タイトル */}
        <div className="mb-10 md:mb-14">
          <h2 className="text-[36px] md:text-[44px] font-black text-[#1A2B4A] leading-tight mb-3">
            受験までの<br className="md:hidden" />
            戦略的カリキュラム
          </h2>
          <p className="text-[#6B7280] text-base md:text-lg">
            春から入試直前まで、逆算型の学習計画で<br className="md:hidden" />
            確実に合格へ導きます
          </p>
        </div>

        {/* 時期選択タブ */}
        <div className="flex gap-2 md:gap-3 mb-6 md:mb-10 overflow-x-auto pb-2 scrollbar-hide">
          {periods.map((period, index) => (
            <button
              key={index}
              onClick={() => setSelectedPeriod(index)}
              className={`px-6 md:px-8 py-3 md:py-4 rounded-full font-bold text-sm md:text-base whitespace-nowrap transition-all cursor-pointer ${
                selectedPeriod === index
                  ? 'bg-[#FF6B35] text-white shadow-lg'
                  : 'bg-white text-[#1A2B4A] border-2 border-[#1A2B4A]'
              }`}
            >
              {period.season}
            </button>
          ))}
        </div>

        {/* 選択された時期の詳細 */}
        <div className="bg-white rounded-3xl shadow-xl overflow-hidden md:flex">
          <div className="relative h-48 md:h-auto md:w-1/2">
            <img
              src={periods[selectedPeriod].image}
              alt={periods[selectedPeriod].title}
              className="w-full h-full object-cover object-top"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent md:bg-gradient-to-r md:from-transparent md:to-black/20"></div>
            <div className="absolute bottom-4 left-4 text-white md:bottom-6 md:left-6">
              <div className="text-sm font-medium mb-1">{periods[selectedPeriod].season}</div>
              <div className="text-2xl md:text-3xl font-bold">{periods[selectedPeriod].title}</div>
            </div>
          </div>
          <div className="p-6 md:p-10 md:w-1/2 md:flex md:items-center">
            <p className="text-[#1A2B4A] text-base md:text-lg leading-relaxed">
              {periods[selectedPeriod].description}
            </p>
          </div>
        </div>

        {/* 重要な3つのポイント */}
        <div className="mt-16 md:mt-24">
          <h3 className="text-[28px] md:text-[36px] font-bold text-[#1A2B4A] text-center mb-8 md:mb-12">
            中3受験で最も重要な<br />
            <span className="inline-flex items-center gap-2">
              <span>3つのこと</span>
              <i className="ri-focus-3-line text-[#FF6B35]"></i>
            </span>
          </h3>

          <div className="space-y-4 md:space-y-0 md:grid md:grid-cols-3 md:gap-6">
            {[
              {
                title: '内申点対策',
                description: '定期テスト対策と提出物管理で内申点を確実にアップ。推薦入試にも有利に。',
                icon: 'ri-file-list-3-line'
              },
              {
                title: '過去問演習',
                description: '志望校の出題傾向を分析し、効率的に得点力を養成します。',
                icon: 'ri-file-text-line'
              },
              {
                title: '学習計画管理',
                description: '受験日から逆算した計画で、無駄なく確実に実力をつけます。',
                icon: 'ri-calendar-check-line'
              }
            ].map((item, index) => (
              <div
                key={index}
                className="bg-[#FAF8F5] rounded-2xl p-6 md:p-8 border-l-4 md:border-l-0 md:border-t-4 border-[#FF6B35]"
              >
                <div className="flex items-start gap-4 md:flex-col">
                  <div className="w-12 h-12 md:w-14 md:h-14 bg-[#FF6B35]/10 rounded-full flex items-center justify-center flex-shrink-0">
                    <i className={`${item.icon} text-[#FF6B35] text-2xl md:text-3xl`}></i>
                  </div>
                  <div>
                    <h4 className="text-[#1A2B4A] font-bold text-lg md:text-xl mb-2 md:mt-4">
                      {item.title}
                    </h4>
                    <p className="text-[#6B7280] text-sm md:text-base leading-relaxed">
                      {item.description}
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
